/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlStatus
 */
export interface ControlStatus {
    /**
     * 
     * @type {boolean}
     * @memberof ControlStatus
     */
    ok: boolean;
}

/**
 * Check if a given object implements the ControlStatus interface.
 */
export function instanceOfControlStatus(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ok" in value;

    return isInstance;
}

export function ControlStatusFromJSON(json: any): ControlStatus {
    return ControlStatusFromJSONTyped(json, false);
}

export function ControlStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ok': json['ok'],
    };
}

export function ControlStatusToJSON(value?: ControlStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ok': value.ok,
    };
}

